var heading_default = {
  "fontElementMap": "P673-",
  "elementSpacing": "JjxKe",
  "headerOne": "NK01F JjxKe",
  "headerTwo": "cWGKd JjxKe",
  "headerThree": "_3WWqV JjxKe",
  "headerFour": "yaWnm JjxKe",
  "headerFive": "g6WNS JjxKe",
  "headerSix": "_9mTsd JjxKe",
  "child": "fk1rB"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
